/**
 * 用户端协议服务
 * 用于前台用户签署协议相关 API 调用
 */

import { userApiClient } from "@/lib/userApiClient";
import type {
  Agreement,
  ConsentStatus,
  SignAgreementsResponse,
  LatestAgreementsResponse,
} from "@/types/consent";

/**
 * 用户端协议服务
 */
export const agreementService = {
  /**
   * 获取最新协议
   * @param regionCode 可选的区域代码
   */
  async getLatestAgreements(regionCode?: string): Promise<Agreement[]> {
    const params = regionCode ? { region_code: regionCode } : {};
    const response = await userApiClient.get<LatestAgreementsResponse>(
      "/agreements/latest",
      { params }
    );
    return response.agreements;
  },

  /**
   * 检查签署状态
   * 返回用户是否需要重新签署协议以及待签署的协议列表
   * @param regionCode 可选的区域代码
   */
  async checkConsentStatus(regionCode?: string): Promise<ConsentStatus> {
    const params = regionCode ? { region_code: regionCode } : {};
    const response = await userApiClient.get<ConsentStatus>(
      "/agreements/consent_status",
      { params }
    );
    return response;
  },

  /**
   * 签署协议
   * @param agreementIds 要签署的协议 ID 列表
   */
  async signAgreements(
    agreementIds: number[]
  ): Promise<SignAgreementsResponse> {
    const response = await userApiClient.post<SignAgreementsResponse>(
      "/agreements/sign",
      { agreement_ids: agreementIds }
    );
    return response;
  },
};

export default agreementService;
